import styled, { css } from "styled-components";
import { getThemeSpace } from "../helpers";
export const TagContainer = styled.div `
	display: flex;
	align-items: center;
	gap: ${getThemeSpace("8")};

	border-radius: 4px;
	background-color: var(${({ bgColor }) => bgColor});
	padding: 0 ${getThemeSpace("8")};

	width: max-content;
	min-height: 20px;

	${({ iconOptions }) => {
    return (iconOptions &&
        css `
				gap: ${getThemeSpace("4")};

				max-height: 20px;
			`);
}}

	&.tag-skeleton {
		background-color: transparent;
	}
`;
//# sourceMappingURL=styles.js.map